<mat-card class="p-4">
    <h2>Decline Guest</h2>
    <div class="d-flex flex-column">
        <p class="mb-2">We're sorry to hear that you need to decline a guest. We're here to help.</p>
        <p class="mb-2">Please tell us below why you would like to decline the guest and we will contact you to discuss the next steps.</p>
        <p class="mb-2">You do not need to provide the guest information or verification results.</p>
    </div>
    <div class="row mt-1">
        <mat-form-field appearance="fill">
            <textarea class="reason-input" rows="10" matInput [(ngModel)]="reason"></textarea>
        </mat-form-field>
    </div>
    <div class="d-flex justify-content-end mt-4">
        <button mat-raised-button style="margin-right:12px;" (click)="onCancelClick()">Cancel</button>
        <button mat-raised-button class="action-button" (click)="onSendClick()">I confirm that I would like to decline this guest</button>
    </div>
</mat-card>